module.exports = __webpack_public_path__ + "assets/img/kurama_logo2.svg";